import { Nullable } from '@/shared/types/app.types'
import { IncidentOriginResponse } from '@/modules/configurationModule/detail/incidents/incidents-origins/services/incidents-origins-laboratories.dto'

export interface ConfigurationIncidentsSeveritiesModalState {
    id: Nullable<number>,
    active: boolean,
    incidentSeverity: Nullable<IncidentOriginResponse>
    daysToClosingDelay: number,
    mandatoryNotification: boolean
}
export const initialConfigurationIncidentsSeveritiesModalState =
    (): ConfigurationIncidentsSeveritiesModalState => ({
        id: null,
        active: true,
        incidentSeverity: null,
        daysToClosingDelay: 0,
        mandatoryNotification: false
    })
